import type { SVGProps } from "react";
const SvgLinux = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#020204"
      d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
    />
    <path
      fill="#FDFDFB"
      d="M105.336 79.061c-.816 1.024-1.341 2.256-1.667 3.525-.318 1.269-.435 2.583-.49 3.897-.1 2.62.064 5.283-.634 7.812-.743 2.7-2.402 5.048-4.024 7.322-2.818 3.952-5.664 8.012-7.05 12.661a22.5 22.5 0 0 0-.825 8.718 93 93 0 0 0-8.138 14.663c-3.426 7.766-5.773 16.031-6.598 24.478-1.015 10.34.308 20.979 4.395 30.531 2.946 6.915 7.35 13.231 13.032 18.161a44.6 44.6 0 0 0 9.516 6.317c11.881 5.845 26.562 5.854 38.244-.372 6.108-3.253 11.264-8.011 16.23-12.823 2.991-2.9 5.973-5.873 8.256-9.353 4.396-6.715 5.927-14.871 6.879-22.837 1.658-13.92 1.713-28.637-4.396-41.261a45.4 45.4 0 0 0-8.265-11.827 64.5 64.5 0 0 0-5.22-17.599c-1.857-4.033-4.114-7.867-5.836-11.945-.707-1.676-1.323-3.398-2.102-5.038-.789-1.64-1.749-3.217-3.072-4.477-1.342-1.287-3.018-2.202-4.785-2.782-1.768-.59-3.634-.852-5.492-.943-3.725-.19-7.45.3-11.174.145-2.964-.118-5.918-.634-8.881-.462-1.478.09-2.955.353-4.332.915-1.378.553-2.647 1.414-3.571 2.574"
    />
    <mask
      id="linux_svg__a"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__b)" mask="url(#linux_svg__a)" opacity={0.25}>
      <path
        fill="url(#linux_svg__c)"
        d="M92.23 116.381c.79 1.187-.498 5.292 17.999 2.664 0 0-3.253.353-6.453 1.096-4.975 1.668-9.307 3.526-12.66 5.991-3.308 2.447-5.736 5.628-8.772 8.355 0 0 4.92-8.99 6.144-11.699 1.233-2.71-.2-2.583.77-6.571s3.345-7.821 3.345-7.821-1.94 5.637-.372 7.985"
      />
    </g>
    <mask
      id="linux_svg__d"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__e)" mask="url(#linux_svg__d)" opacity={0.42}>
      <path
        fill="url(#linux_svg__f)"
        d="M151.692 115.301c-3.77 2.628-5.981 2.32-10.549 2.828-4.576.516-16.947.326-16.947.326s1.786-.027 5.764.707c3.969.743 12.062 1.45 16.621 3.181 4.567 1.74 6.225 2.238 8.999 3.987 3.942 2.493 6.842 6.398 10.612 9.135 0 0 .181-3.625-1.341-6.334-1.523-2.71-5.619-6.978-6.825-10.966-1.196-3.987-1.776-11.817-1.776-11.817s-.797 6.334-4.558 8.953"
      />
    </g>
    <mask
      id="linux_svg__g"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__h)" mask="url(#linux_svg__g)" opacity={0.2}>
      <path
        fill="url(#linux_svg__i)"
        d="M116.247 109.703a54 54 0 0 1-.543 3.389c-.109.553-.236 1.106-.435 1.632-.209.525-.508 1.033-.925 1.404-.371.336-.815.562-1.268.771a19.5 19.5 0 0 1-5.547 1.577c.762.054 1.523.126 2.293.208.48.054.961.109 1.423.227.471.126.933.308 1.323.589.426.317.761.743 1.015 1.214.498.924.662 1.994.752 3.054.118 1.341.127 2.701.027 4.042.091-.897.281-1.794.562-2.646.517-1.559 1.332-3.009 2.438-4.214a9.7 9.7 0 0 1 1.45-1.287 8.03 8.03 0 0 1 5.655-1.369 8.8 8.8 0 0 1-5.619-1.749c-.815-.616-1.522-1.377-2.012-2.265a6.34 6.34 0 0 1-.589-4.577"
      />
    </g>
    <mask
      id="linux_svg__j"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__k)" mask="url(#linux_svg__j)" opacity={0.11}>
      <path
        fill="#000"
        d="M111.426 136.283a68 68 0 0 0-1.967 11.156c-.498 5.32-.381 10.676-.671 16.013-.235 4.523-.77 9.099.019 13.567a22.9 22.9 0 0 0 1.993 6.144 21 21 0 0 0 .327-2.238c.335-3.625-.272-7.259-.481-10.884-.362-6.362.517-12.724.879-19.086.272-4.884.245-9.787-.099-14.672"
      />
    </g>
    <mask
      id="linux_svg__l"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__m)" mask="url(#linux_svg__l)" opacity={0.75}>
      <path
        fill="#7C7C7C"
        d="M175.073 130.927c.933-.145 6.651 4.722 5.872 6.534-.779 1.803-2.257.716-3.308.725-1.051.018-3.924 1.323-4.404.498-.49-.824 1.269-2.745 2.184-4.359.743-1.296-1.269-3.253-.344-3.398"
      />
    </g>
    <mask
      id="linux_svg__n"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__o)" mask="url(#linux_svg__n)">
      <path
        fill="#7C7C7C"
        d="M140.128 22.077c-2.003 1.413-1.133 3.18-.272 4.948.861 1.776-1.894 6.878-1.921 7.096s5.419-2.583 6.905-4.414c1.758-2.148 6.19 2.918 5.945 2.148.009-1.377-8.654-11.183-10.657-9.778"
      />
    </g>
    <mask
      id="linux_svg__p"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__q)" mask="url(#linux_svg__p)">
      <path
        fill="#838384"
        d="M155.307 81.446c-1.685 1.54.798 3.852 1.967 6.561.734 1.686 2.755 4.07 4.712 3.689 1.478-.29 2.384-2.411 2.248-3.897-.272-2.882-2.701-3.562-4.468-4.55-1.396-.779-3.271-2.881-4.459-1.803"
      />
    </g>
    <path
      fill="#020204"
      d="M87.982 103.45c-5.528 6.271-11.21 12.352-14.328 19.14-1.55 3.444-2.274 7.187-3.335 10.812-1.196 4.114-2.827 8.101-4.658 11.98-1.694 3.58-3.561 7.078-5.42 10.567-1.359 2.547-2.736 5.138-3.207 7.984-.372 2.248-.163 4.568.417 6.77.57 2.202 1.486 4.304 2.528 6.325 4.422 8.655 11.065 16.104 18.932 21.814a67.4 67.4 0 0 0 11.4 6.661c2.175.987 4.459 1.876 6.851 1.912 1.197.027 2.402-.172 3.498-.653 1.088-.48 2.067-1.25 2.719-2.256.798-1.233 1.07-2.764.906-4.223-.163-1.459-.734-2.855-1.495-4.106-1.867-3.063-4.812-5.283-7.649-7.476a257 257 0 0 1-17.717-15.026c-1.595-1.495-3.199-3.027-4.314-4.912-1.087-1.83-1.676-3.915-2.075-6.008-1.096-5.737-.815-11.772 1.133-17.282.77-2.157 1.776-4.214 2.755-6.28 1.686-3.58 3.28-7.232 5.5-10.513 2.765-4.087 6.462-7.549 8.71-11.935 1.903-3.707 2.673-7.866 3.407-11.963.58-3.208 1.677-6.343 2.239-9.551-1.097 2.084-4.631 5.5-6.797 8.219"
    />
    <mask
      id="linux_svg__r"
      width={49}
      height={113}
      x={56}
      y={95}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M87.982 103.45c-5.528 6.271-11.21 12.352-14.328 19.14-1.55 3.444-2.274 7.187-3.335 10.812-1.196 4.114-2.827 8.101-4.658 11.98-1.694 3.58-3.561 7.078-5.42 10.567-1.359 2.547-2.736 5.138-3.207 7.984-.372 2.248-.163 4.568.417 6.77.57 2.202 1.486 4.304 2.528 6.325 4.422 8.655 11.065 16.104 18.932 21.814a67.4 67.4 0 0 0 11.4 6.661c2.175.987 4.459 1.876 6.851 1.912 1.197.027 2.402-.172 3.498-.653 1.088-.48 2.067-1.25 2.719-2.256.798-1.233 1.07-2.764.906-4.223-.163-1.459-.734-2.855-1.495-4.106-1.867-3.063-4.812-5.283-7.649-7.476a257 257 0 0 1-17.717-15.026c-1.595-1.495-3.199-3.027-4.314-4.912-1.087-1.83-1.676-3.915-2.075-6.008-1.096-5.737-.815-11.772 1.133-17.282.77-2.157 1.776-4.214 2.755-6.28 1.686-3.58 3.28-7.232 5.5-10.513 2.765-4.087 6.462-7.549 8.71-11.935 1.903-3.707 2.673-7.866 3.407-11.963.58-3.208 1.677-6.343 2.239-9.551-1.097 2.084-4.631 5.5-6.797 8.219"
      />
    </mask>
    <g filter="url(#linux_svg__s)" mask="url(#linux_svg__r)" opacity={0.95}>
      <path
        fill="#7C7C7C"
        d="M81.62 126.278a25.7 25.7 0 0 0-4.649 5.718c-2.084 3.48-3.308 7.395-4.83 11.156-1.124 2.8-2.438 5.619-2.592 8.636-.081 1.55.145 3.1.2 4.649.054 1.55-.091 3.163-.852 4.514a5.48 5.48 0 0 1-2.919 2.455 8.66 8.66 0 0 1 4.17 3.018c.87 1.178 1.431 2.547 2.183 3.788.617 1.015 1.369 1.958 2.302 2.692.925.743 2.04 1.269 3.208 1.414a5.65 5.65 0 0 0 4.504-1.432 105.6 105.6 0 0 1 4.024-42.023c.263-.852.535-1.713.607-2.601.064-.897-.108-1.839-.652-2.546a2.7 2.7 0 0 0-2.51-1.061 2.8 2.8 0 0 0-1.315.517c-.38.29-.688.671-.879 1.106"
      />
    </g>
    <path
      fill="#020204"
      d="M177.501 127.203c4.749 3.824 7.767 9.597 8.7 15.624.725 4.694.254 9.524-.806 14.155-1.06 4.64-2.692 9.117-4.323 13.594-.643 1.776-1.296 3.58-1.55 5.455-.262 1.885-.099 3.87.807 5.538 1.042 1.912 2.982 3.226 5.066 3.842 2.057.616 4.277.598 6.362.082 2.084-.517 5.591-1.187 7.286-2.511 4.305-3.344 5.329-9.153 6.353-14.246 1.06-5.319.544-10.893-.39-16.267-1.278-7.331-3.426-14.491-6.153-21.405a74.6 74.6 0 0 0-7.649-14.464c-3.009-4.432-7.268-7.885-10.422-12.216-1.096-1.505-2.411-3.063-3.48-4.586-2.32-3.28-1.794-2.664-3.235-4.794-1.042-1.54-2.692-2.066-4.423-2.737-1.74-.67-3.679-.87-5.473-.371-2.357.661-4.287 2.528-5.311 4.748-1.024 2.23-1.205 4.785-.807 7.205.517 3.117 1.94 6.017 3.553 8.736 1.812 3.072 3.915 6.036 6.661 8.319 2.864 2.384 6.325 3.961 9.234 6.299"
    />
    <mask
      id="linux_svg__t"
      width={49}
      height={95}
      x={157}
      y={91}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M177.501 127.203c4.749 3.824 7.767 9.597 8.7 15.624.725 4.694.254 9.524-.806 14.155-1.06 4.64-2.692 9.117-4.323 13.594-.643 1.776-1.296 3.58-1.55 5.455-.262 1.885-.099 3.87.807 5.538 1.042 1.912 2.982 3.226 5.066 3.842 2.057.616 4.277.598 6.362.082 2.084-.517 5.591-1.187 7.286-2.511 4.305-3.344 5.329-9.153 6.353-14.246 1.06-5.319.544-10.893-.39-16.267-1.278-7.331-3.426-14.491-6.153-21.405a74.6 74.6 0 0 0-7.649-14.464c-3.009-4.432-7.268-7.885-10.422-12.216-1.096-1.505-2.411-3.063-3.48-4.586-2.32-3.28-1.794-2.664-3.235-4.794-1.042-1.54-2.692-2.066-4.423-2.737-1.74-.67-3.679-.87-5.473-.371-2.357.661-4.287 2.528-5.311 4.748-1.024 2.23-1.205 4.785-.807 7.205.517 3.117 1.94 6.017 3.553 8.736 1.812 3.072 3.915 6.036 6.661 8.319 2.864 2.384 6.325 3.961 9.234 6.299"
      />
    </mask>
    <g filter="url(#linux_svg__u)" mask="url(#linux_svg__t)">
      <path
        fill="#838384"
        d="M166.318 119.834c.381.362.78.734 1.188 1.078 2.918 2.384 4.467 5.057 7.431 7.395 4.839 3.825 9.742 10.422 10.693 16.449.744 4.703-.235 7.259-1.431 12.796-1.197 5.546-4.586 13.394-6.426 18.741-.725 2.13 1.487 1.251 1.197 3.498a13.2 13.2 0 0 0-.028 3.326c.019-.208.028-.435.055-.643.353-3.063 1.287-6.009 2.311-8.9 1.966-5.555 4.223-11.01 5.782-16.72 1.558-5.7 1.386-9.805.57-14.708-1.024-6.172-4.612-11.863-9.687-15.624-3.598-2.655-7.83-4.359-11.655-6.688"
      />
    </g>
    <path
      fill="url(#linux_svg__v)"
      d="M61.7 170.891c1.251-.516 2.656-.616 3.979-.371 1.332.245 2.592.825 3.706 1.577 2.239 1.522 3.897 3.733 5.483 5.927 3.652 5.02 7.16 10.15 10.35 15.478 2.582 4.332 4.948 8.8 7.938 12.851 1.949 2.655 4.142 5.111 6.1 7.748 1.957 2.647 3.688 5.51 4.558 8.682 1.133 4.124.689 8.664-1.269 12.461-1.377 2.673-3.498 4.966-6.072 6.516s-5.283 2.238-8.292 2.238c-4.776 0-9.443-2.564-13.884-4.331-9.044-3.607-18.868-4.731-28.193-7.54-2.864-.861-5.682-1.885-8.564-2.674-1.287-.353-2.583-.661-3.797-1.214-1.215-.544-2.347-1.369-3.018-2.511-.517-.888-.725-1.93-.725-2.954 0-1.033.254-2.048.607-3.009.698-1.93 1.83-3.679 2.592-5.591 1.242-3.118 1.468-6.552 1.296-9.905-.163-3.345-.707-6.67-.933-10.015-.11-1.495-.145-3.008.145-4.485.28-1.469.915-2.909 1.993-3.943.997-.96 2.311-1.531 3.67-1.812 1.35-.281 2.747-.29 4.124-.263s2.764.109 4.142-.009c1.377-.109 2.764-.417 3.96-1.106 1.142-.652 2.075-1.622 2.846-2.682s1.395-2.22 2.038-3.371c.635-1.142 1.297-2.284 2.14-3.299.833-1.015 1.866-1.894 3.08-2.393"
    />
    <mask
      id="linux_svg__w"
      width={75}
      height={74}
      x={30}
      y={170}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M61.7 170.891c1.251-.516 2.656-.616 3.979-.371 1.332.245 2.592.825 3.706 1.577 2.239 1.522 3.897 3.733 5.483 5.927 3.652 5.02 7.16 10.15 10.35 15.478 2.582 4.332 4.948 8.8 7.938 12.851 1.949 2.655 4.142 5.111 6.1 7.748 1.957 2.647 3.688 5.51 4.558 8.682 1.133 4.124.689 8.664-1.269 12.461-1.377 2.673-3.498 4.966-6.072 6.516s-5.283 2.238-8.292 2.238c-4.776 0-9.443-2.564-13.884-4.331-9.044-3.607-18.868-4.731-28.193-7.54-2.864-.861-5.682-1.885-8.564-2.674-1.287-.353-2.583-.661-3.797-1.214-1.215-.544-2.347-1.369-3.018-2.511-.517-.888-.725-1.93-.725-2.954 0-1.033.254-2.048.607-3.009.698-1.93 1.83-3.679 2.592-5.591 1.242-3.118 1.468-6.552 1.296-9.905-.163-3.345-.707-6.67-.933-10.015-.11-1.495-.145-3.008.145-4.485.28-1.469.915-2.909 1.993-3.943.997-.96 2.311-1.531 3.67-1.812 1.35-.281 2.747-.29 4.124-.263s2.764.109 4.142-.009c1.377-.109 2.764-.417 3.96-1.106 1.142-.652 2.075-1.622 2.846-2.682s1.395-2.22 2.038-3.371c.635-1.142 1.297-2.284 2.14-3.299.833-1.015 1.866-1.894 3.08-2.393"
      />
    </mask>
    <g filter="url(#linux_svg__x)" mask="url(#linux_svg__w)">
      <path
        fill="#D99A03"
        d="M63.676 173.039c1.133-.453 2.42-.507 3.607-.235 1.196.272 2.31.852 3.271 1.604 1.94 1.495 3.28 3.598 4.577 5.673 3.1 5.02 6.126 10.104 8.99 15.279 2.175 3.906 4.241 7.885 6.905 11.464 1.767 2.375 3.788 4.559 5.592 6.906s3.407 4.903 4.205 7.757c1.033 3.671.616 7.74-1.16 11.111-1.287 2.429-3.245 4.495-5.619 5.872a14.44 14.44 0 0 1-7.875 1.94c-4.368-.2-8.365-2.384-12.48-3.861-7.893-2.864-16.438-3.253-24.54-5.483-2.9-.788-5.728-1.839-8.637-2.573-1.296-.327-2.61-.599-3.833-1.115-1.224-.517-2.375-1.314-3.045-2.465-.49-.861-.689-1.867-.662-2.855.036-.988.281-1.966.634-2.891.707-1.848 1.813-3.516 2.52-5.365 1.078-2.791 1.214-5.863 1.015-8.845-.2-2.981-.725-5.945-.906-8.926-.073-1.341-.091-2.692.18-3.997.273-1.314.844-2.583 1.795-3.525 1.033-1.024 2.447-1.577 3.888-1.803 1.432-.218 2.891-.118 4.332.009 1.45.126 2.9.29 4.35.208 1.45-.091 2.918-.444 4.114-1.26 1.088-.734 1.903-1.812 2.529-2.963s1.07-2.393 1.55-3.607c.47-1.223.987-2.438 1.73-3.525.743-1.079 1.75-2.03 2.973-2.529"
      />
    </g>
    <mask
      id="linux_svg__y"
      width={75}
      height={74}
      x={30}
      y={170}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M61.7 170.891c1.251-.516 2.656-.616 3.979-.371 1.332.245 2.592.825 3.706 1.577 2.239 1.522 3.897 3.733 5.483 5.927 3.652 5.02 7.16 10.15 10.35 15.478 2.582 4.332 4.948 8.8 7.938 12.851 1.949 2.655 4.142 5.111 6.1 7.748 1.957 2.647 3.688 5.51 4.558 8.682 1.133 4.124.689 8.664-1.269 12.461-1.377 2.673-3.498 4.966-6.072 6.516s-5.283 2.238-8.292 2.238c-4.776 0-9.443-2.564-13.884-4.331-9.044-3.607-18.868-4.731-28.193-7.54-2.864-.861-5.682-1.885-8.564-2.674-1.287-.353-2.583-.661-3.797-1.214-1.215-.544-2.347-1.369-3.018-2.511-.517-.888-.725-1.93-.725-2.954 0-1.033.254-2.048.607-3.009.698-1.93 1.83-3.679 2.592-5.591 1.242-3.118 1.468-6.552 1.296-9.905-.163-3.345-.707-6.67-.933-10.015-.11-1.495-.145-3.008.145-4.485.28-1.469.915-2.909 1.993-3.943.997-.96 2.311-1.531 3.67-1.812 1.35-.281 2.747-.29 4.124-.263s2.764.109 4.142-.009c1.377-.109 2.764-.417 3.96-1.106 1.142-.652 2.075-1.622 2.846-2.682s1.395-2.22 2.038-3.371c.635-1.142 1.297-2.284 2.14-3.299.833-1.015 1.866-1.894 3.08-2.393"
      />
    </mask>
    <g filter="url(#linux_svg__z)" mask="url(#linux_svg__y)">
      <path
        fill="#F5BD0C"
        d="M62.616 170.204c1.106-.544 2.402-.653 3.607-.408 1.205.244 2.33.833 3.28 1.604 1.895 1.54 3.11 3.743 4.233 5.899 2.574 4.949 4.984 10.005 8.065 14.673 2.248 3.38 4.83 6.525 7.096 9.896 3.072 4.558 5.574 9.579 6.607 14.953.689 3.625.67 7.531-1.07 10.784-1.15 2.148-3.008 3.906-5.21 5.003-2.193 1.105-4.722 1.549-7.178 1.332-3.87-.335-7.377-2.239-11.02-3.571-6.461-2.347-13.448-2.918-20.1-4.694-2.8-.743-5.556-1.713-8.392-2.302-1.26-.263-2.538-.453-3.734-.906s-2.329-1.206-2.945-2.311c-.426-.78-.571-1.686-.508-2.574.064-.879.326-1.74.67-2.565.699-1.631 1.723-3.135 2.257-4.821.798-2.492.472-5.184-.127-7.73-.588-2.538-1.45-5.03-1.712-7.622-.118-1.151-.118-2.329.154-3.461.263-1.133.797-2.221 1.64-3.027 1.088-1.043 2.61-1.568 4.133-1.713 1.513-.145 3.035.054 4.54.272 1.504.217 3.027.453 4.54.38 1.523-.063 3.072-.462 4.26-1.395 1.178-.925 1.92-2.293 2.347-3.707.426-1.423.562-2.9.734-4.368s.39-2.954.96-4.323c.571-1.368 1.532-2.628 2.873-3.298"
      />
    </g>
    <mask
      id="linux_svg__A"
      width={75}
      height={74}
      x={30}
      y={170}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M61.7 170.891c1.251-.516 2.656-.616 3.979-.371 1.332.245 2.592.825 3.706 1.577 2.239 1.522 3.897 3.733 5.483 5.927 3.652 5.02 7.16 10.15 10.35 15.478 2.582 4.332 4.948 8.8 7.938 12.851 1.949 2.655 4.142 5.111 6.1 7.748 1.957 2.647 3.688 5.51 4.558 8.682 1.133 4.124.689 8.664-1.269 12.461-1.377 2.673-3.498 4.966-6.072 6.516s-5.283 2.238-8.292 2.238c-4.776 0-9.443-2.564-13.884-4.331-9.044-3.607-18.868-4.731-28.193-7.54-2.864-.861-5.682-1.885-8.564-2.674-1.287-.353-2.583-.661-3.797-1.214-1.215-.544-2.347-1.369-3.018-2.511-.517-.888-.725-1.93-.725-2.954 0-1.033.254-2.048.607-3.009.698-1.93 1.83-3.679 2.592-5.591 1.242-3.118 1.468-6.552 1.296-9.905-.163-3.345-.707-6.67-.933-10.015-.11-1.495-.145-3.008.145-4.485.28-1.469.915-2.909 1.993-3.943.997-.96 2.311-1.531 3.67-1.812 1.35-.281 2.747-.29 4.124-.263s2.764.109 4.142-.009c1.377-.109 2.764-.417 3.96-1.106 1.142-.652 2.075-1.622 2.846-2.682s1.395-2.22 2.038-3.371c.635-1.142 1.297-2.284 2.14-3.299.833-1.015 1.866-1.894 3.08-2.393"
      />
    </mask>
    <g filter="url(#linux_svg__B)" mask="url(#linux_svg__A)">
      <path
        fill="url(#linux_svg__C)"
        d="M76.4 182.562c2.038 3.68 3.28 7.903 5.301 11.619 1.858 3.416 3.97 6.932 5.854 10.077.843 1.405 2.8 3.562 4.776 6.906 1.795 3.027 3.607 7.259 4.622 8.681-.58-1.667-1.776-6.135-3.208-9.316-1.332-2.972-2.891-4.667-3.843-6.271-1.885-3.145-3.924-5.981-5.863-8.981-2.673-4.141-4.712-8.772-7.64-12.715"
      />
    </g>
    <mask
      id="linux_svg__D"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__E)" mask="url(#linux_svg__D)" opacity={0.2}>
      <path
        fill="url(#linux_svg__F)"
        d="M210.071 207.396a13 13 0 0 1-1.64 3.444c-1.586 2.347-3.897 4.123-6.199 5.754-3.924 2.783-8.02 5.338-11.681 8.501-2.447 2.121-4.686 4.504-6.752 7.005-1.767 2.139-3.435 4.386-5.456 6.29-2.039 1.921-4.431 3.48-7.014 4.322-3.145 1.024-6.461.979-9.488.2-2.121-.544-4.196-1.486-5.51-3.199s-1.74-4.024-1.894-6.29c-.272-4.005.208-8.092.643-12.161.363-3.381.698-6.761.834-10.132.245-6.136-.163-12.207-.988-18.171-.145-1.005-.29-2.011-.208-3.035.081-1.034.426-2.103 1.151-2.9.67-.735 1.604-1.17 2.528-1.378.924-.217 1.867-.227 2.8-.254 2.202-.054 4.405-.19 6.571.009 1.368.118 2.709.372 4.069.499 2.274.217 4.64.109 6.923-.562 2.456-.725 4.794-2.075 7.296-2.447a10.4 10.4 0 0 1 3.045.009c1.015.136 2.03.417 2.809 1.042.598.472 1.033 1.115 1.368 1.804.508 1.033.816 2.166.997 3.335.154 1.033.218 2.093.481 3.09.435 1.64 1.431 3.036 2.619 4.169 1.196 1.133 2.582 2.03 3.978 2.918 1.387.879 2.782 1.749 4.259 2.474.698.344 1.414.652 2.076 1.042.67.399 1.287.879 1.731 1.514.598.86.833 1.993.652 3.108"
      />
    </g>
    <path
      fill="url(#linux_svg__G)"
      d="M223.456 214.02c-2.048 2.428-4.893 4.033-7.73 5.483-4.83 2.455-9.842 4.621-14.382 7.585-3.045 1.984-5.854 4.314-8.482 6.824-2.248 2.148-4.378 4.44-6.897 6.262-2.547 1.84-5.483 3.172-8.591 3.634-.861.127-1.722.19-2.592.19-2.936 0-5.873-.706-8.573-1.885-2.447-1.06-4.803-2.591-6.217-4.857-1.414-2.284-1.74-5.066-1.74-7.758-.009-4.739.87-9.434 1.695-14.11.688-3.888 1.341-7.775 1.767-11.699.77-7.124.761-14.328.254-21.488-.091-1.196-.191-2.401-.009-3.588.181-1.187.67-2.375 1.576-3.154.843-.725 1.967-1.051 3.082-1.106 1.105-.063 2.211.109 3.307.272 2.583.381 5.193.671 7.722 1.341 1.595.417 3.153.979 4.739 1.414 2.665.716 5.447 1.06 8.175.743 2.945-.344 5.809-1.45 8.772-1.377 1.215.027 2.42.254 3.58.625 1.178.372 2.347.906 3.217 1.795.662.67 1.124 1.513 1.468 2.392.517 1.305.798 2.701.915 4.096.1 1.242.082 2.501.318 3.725.389 2.003 1.45 3.842 2.755 5.41 1.314 1.577 2.881 2.909 4.449 4.223s3.136 2.619 4.822 3.77c.788.544 1.604 1.052 2.356 1.641.752.598 1.441 1.286 1.912 2.12a4.94 4.94 0 0 1 .417 3.816c-.408 1.295-1.16 2.555-2.085 3.661"
    />
    <mask
      id="linux_svg__H"
      width={68}
      height={70}
      x={158}
      y={174}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M223.456 214.02c-2.048 2.428-4.893 4.033-7.73 5.483-4.83 2.455-9.842 4.621-14.382 7.585-3.045 1.984-5.854 4.314-8.482 6.824-2.248 2.148-4.378 4.44-6.897 6.262-2.547 1.84-5.483 3.172-8.591 3.634-.861.127-1.722.19-2.592.19-2.936 0-5.873-.706-8.573-1.885-2.447-1.06-4.803-2.591-6.217-4.857-1.414-2.284-1.74-5.066-1.74-7.758-.009-4.739.87-9.434 1.695-14.11.688-3.888 1.341-7.775 1.767-11.699.77-7.124.761-14.328.254-21.488-.091-1.196-.191-2.401-.009-3.588.181-1.187.67-2.375 1.576-3.154.843-.725 1.967-1.051 3.082-1.106 1.105-.063 2.211.109 3.307.272 2.583.381 5.193.671 7.722 1.341 1.595.417 3.153.979 4.739 1.414 2.665.716 5.447 1.06 8.175.743 2.945-.344 5.809-1.45 8.772-1.377 1.215.027 2.42.254 3.58.625 1.178.372 2.347.906 3.217 1.795.662.67 1.124 1.513 1.468 2.392.517 1.305.798 2.701.915 4.096.1 1.242.082 2.501.318 3.725.389 2.003 1.45 3.842 2.755 5.41 1.314 1.577 2.881 2.909 4.449 4.223s3.136 2.619 4.822 3.77c.788.544 1.604 1.052 2.356 1.641.752.598 1.441 1.286 1.912 2.12a4.94 4.94 0 0 1 .417 3.816c-.408 1.295-1.16 2.555-2.085 3.661"
      />
    </mask>
    <g filter="url(#linux_svg__I)" mask="url(#linux_svg__H)">
      <path
        fill="#CD8907"
        d="M223.222 207.859a11.8 11.8 0 0 1-2.012 3.325c-1.876 2.194-4.468 3.635-7.051 4.93-4.422 2.212-8.99 4.151-13.141 6.815-2.773 1.786-5.346 3.879-7.748 6.145-2.048 1.93-3.996 3.996-6.298 5.628-2.329 1.658-5.012 2.845-7.839 3.262-3.444.508-6.997-.145-10.196-1.513-2.229-.961-4.386-2.32-5.682-4.378-1.287-2.048-1.586-4.549-1.586-6.969-.018-4.268.789-8.491 1.55-12.687.634-3.489 1.232-6.987 1.613-10.512.689-6.417.662-12.887.227-19.322-.073-1.078-.154-2.166.009-3.235s.607-2.13 1.422-2.837c.771-.661 1.804-.951 2.819-.996 1.006-.055 2.012.108 3.018.253 2.365.345 4.739.608 7.05 1.206 1.459.38 2.882.888 4.332 1.268 2.429.653 4.975.961 7.468.671 2.691-.308 5.301-1.305 8.002-1.242 1.114.028 2.211.236 3.271.562 1.079.336 2.148.816 2.946 1.613.598.608 1.006 1.369 1.341 2.157.48 1.169.806 2.42.825 3.689.027 1.323-.254 2.646-.082 3.96.145 1.06.598 2.066 1.178 2.973.571.906 1.269 1.73 1.967 2.546 1.341 1.586 2.682 3.199 4.368 4.414 1.912 1.386 4.187 2.202 6.162 3.489.589.389 1.16.824 1.577 1.395.707.961.888 2.266.49 3.39"
      />
    </g>
    <mask
      id="linux_svg__J"
      width={68}
      height={70}
      x={158}
      y={174}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M223.456 214.02c-2.048 2.428-4.893 4.033-7.73 5.483-4.83 2.455-9.842 4.621-14.382 7.585-3.045 1.984-5.854 4.314-8.482 6.824-2.248 2.148-4.378 4.44-6.897 6.262-2.547 1.84-5.483 3.172-8.591 3.634-.861.127-1.722.19-2.592.19-2.936 0-5.873-.706-8.573-1.885-2.447-1.06-4.803-2.591-6.217-4.857-1.414-2.284-1.74-5.066-1.74-7.758-.009-4.739.87-9.434 1.695-14.11.688-3.888 1.341-7.775 1.767-11.699.77-7.124.761-14.328.254-21.488-.091-1.196-.191-2.401-.009-3.588.181-1.187.67-2.375 1.576-3.154.843-.725 1.967-1.051 3.082-1.106 1.105-.063 2.211.109 3.307.272 2.583.381 5.193.671 7.722 1.341 1.595.417 3.153.979 4.739 1.414 2.665.716 5.447 1.06 8.175.743 2.945-.344 5.809-1.45 8.772-1.377 1.215.027 2.42.254 3.58.625 1.178.372 2.347.906 3.217 1.795.662.67 1.124 1.513 1.468 2.392.517 1.305.798 2.701.915 4.096.1 1.242.082 2.501.318 3.725.389 2.003 1.45 3.842 2.755 5.41 1.314 1.577 2.881 2.909 4.449 4.223s3.136 2.619 4.822 3.77c.788.544 1.604 1.052 2.356 1.641.752.598 1.441 1.286 1.912 2.12a4.94 4.94 0 0 1 .417 3.816c-.408 1.295-1.16 2.555-2.085 3.661"
      />
    </mask>
    <g filter="url(#linux_svg__K)" mask="url(#linux_svg__J)">
      <path
        fill="#F5C021"
        d="M222.949 206.49a14.8 14.8 0 0 1-2.067 3.362c-1.921 2.338-4.522 3.942-7.249 4.975-4.505 1.704-9.416 1.93-13.83 3.87-2.691 1.178-5.12 2.954-7.576 4.64-1.976 1.35-4.006 2.664-6.181 3.607-2.465 1.078-5.075 1.676-7.703 2.102-1.667.263-3.362.462-5.048.372s-3.371-.49-4.866-1.351c-1.124-.652-2.139-1.585-2.746-2.809-.662-1.35-.779-2.936-.77-4.477.045-4.078.924-8.12.897-12.207-.027-3.561-.734-7.069-.934-10.621-.389-6.833 1.079-13.775-.217-20.472-.199-1.079-.48-2.148-.471-3.245.009-.543.09-1.096.281-1.604.199-.498.507-.96.915-1.287a2.9 2.9 0 0 1 1.187-.507 4 4 0 0 1 1.278.009c.843.136 1.649.462 2.474.707 2.356.707 4.848.689 7.25 1.223 1.504.327 2.954.879 4.45 1.278 2.492.689 5.102.979 7.666.68 2.755-.326 5.447-1.323 8.22-1.251 1.142.027 2.266.236 3.362.562s2.193.789 3.027 1.631c.589.608 1.024 1.378 1.369 2.175.516 1.169.87 2.438.861 3.725-.01.671-.109 1.332-.173 2.003-.054.67-.072 1.35.082 1.994.163.652.498 1.241.879 1.776s.816 1.015 1.214 1.54c1.106 1.459 1.903 3.163 2.764 4.804.861 1.64 1.831 3.262 3.199 4.449 1.858 1.604 4.26 2.248 6.335 3.525.607.372 1.187.807 1.613 1.405.345.471.571 1.042.662 1.64.081.59.027 1.215-.154 1.777"
      />
    </g>
    <mask
      id="linux_svg__L"
      width={68}
      height={70}
      x={158}
      y={174}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M223.456 214.02c-2.048 2.428-4.893 4.033-7.73 5.483-4.83 2.455-9.842 4.621-14.382 7.585-3.045 1.984-5.854 4.314-8.482 6.824-2.248 2.148-4.378 4.44-6.897 6.262-2.547 1.84-5.483 3.172-8.591 3.634-.861.127-1.722.19-2.592.19-2.936 0-5.873-.706-8.573-1.885-2.447-1.06-4.803-2.591-6.217-4.857-1.414-2.284-1.74-5.066-1.74-7.758-.009-4.739.87-9.434 1.695-14.11.688-3.888 1.341-7.775 1.767-11.699.77-7.124.761-14.328.254-21.488-.091-1.196-.191-2.401-.009-3.588.181-1.187.67-2.375 1.576-3.154.843-.725 1.967-1.051 3.082-1.106 1.105-.063 2.211.109 3.307.272 2.583.381 5.193.671 7.722 1.341 1.595.417 3.153.979 4.739 1.414 2.665.716 5.447 1.06 8.175.743 2.945-.344 5.809-1.45 8.772-1.377 1.215.027 2.42.254 3.58.625 1.178.372 2.347.906 3.217 1.795.662.67 1.124 1.513 1.468 2.392.517 1.305.798 2.701.915 4.096.1 1.242.082 2.501.318 3.725.389 2.003 1.45 3.842 2.755 5.41 1.314 1.577 2.881 2.909 4.449 4.223s3.136 2.619 4.822 3.77c.788.544 1.604 1.052 2.356 1.641.752.598 1.441 1.286 1.912 2.12a4.94 4.94 0 0 1 .417 3.816c-.408 1.295-1.16 2.555-2.085 3.661"
      />
    </mask>
    <g filter="url(#linux_svg__M)" mask="url(#linux_svg__L)">
      <path
        fill="url(#linux_svg__N)"
        d="M164.197 176.555c2.555-.689 4.73 1.25 6.588 2.709 1.196 1.024 2.936.771 4.405.816 2.437-.082 4.857.408 7.295.109 4.803-.408 9.506-1.586 14.328-1.786 2.302-.145 4.893-.28 6.878 1.061.807.562 1.994 2.927 2.782 2.039-.326-2.483-2.166-4.885-4.631-5.546-1.939-.309-3.897.226-5.854.054-5.791-.136-11.555-1.214-17.364-.906-4.042.036-8.074-.154-12.116-.308-1.586-.327-2.148 1.078-3.009 1.622.227.172.308.226.698.136"
      />
    </g>
    <mask
      id="linux_svg__O"
      width={68}
      height={70}
      x={158}
      y={174}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M223.455 214.022c-2.049 2.428-4.894 4.032-7.731 5.482-4.83 2.456-9.842 4.622-14.382 7.586-3.045 1.984-5.854 4.314-8.482 6.824-2.248 2.148-4.378 4.44-6.897 6.262-2.546 1.84-5.483 3.172-8.591 3.634-.861.127-1.722.19-2.592.19-2.936 0-5.872-.707-8.573-1.885-2.447-1.06-4.803-2.592-6.217-4.857-1.414-2.284-1.74-5.066-1.74-7.758-.009-4.739.87-9.434 1.695-14.11.688-3.888 1.341-7.775 1.767-11.7.77-7.123.761-14.327.254-21.487-.091-1.196-.191-2.401-.009-3.588.181-1.188.67-2.375 1.576-3.154.843-.725 1.967-1.051 3.082-1.106 1.105-.063 2.211.109 3.308.272 2.582.381 5.192.671 7.721 1.341 1.595.417 3.153.979 4.739 1.414 2.665.716 5.447 1.06 8.175.743 2.945-.344 5.809-1.45 8.772-1.377 1.215.027 2.42.254 3.58.625 1.178.372 2.347.906 3.217 1.794.662.671 1.124 1.514 1.468 2.393.517 1.305.798 2.701.916 4.096.099 1.242.081 2.501.317 3.725.389 2.003 1.45 3.842 2.755 5.41 1.314 1.577 2.882 2.909 4.449 4.223 1.568 1.314 3.136 2.619 4.822 3.77.788.544 1.604 1.051 2.356 1.641.752.598 1.441 1.286 1.912 2.12.408.734.625 1.559.625 2.402 0 .471-.063.942-.208 1.413-.408 1.296-1.16 2.556-2.084 3.662"
      />
    </mask>
    <g filter="url(#linux_svg__P)" mask="url(#linux_svg__O)" opacity={0.35}>
      <path
        fill="url(#linux_svg__Q)"
        d="M198.097 182.022c-.435-.861-1.232-1.504-2.129-1.876-.888-.372-1.867-.498-2.837-.489-1.93.018-3.851.516-5.782.353-1.622-.145-3.162-.752-4.748-1.142-1.641-.399-3.381-.553-5.003-.109-1.74.472-3.271 1.641-4.232 3.163-.852 1.341-1.251 2.927-1.378 4.513-.126 1.586.009 3.172.173 4.758.108 1.142.244 2.284.516 3.399.281 1.114.707 2.202 1.378 3.135.969 1.341 2.41 2.302 3.96 2.873 2.537.933 5.419.888 7.912-.136 4.422-1.921 8.165-5.365 10.439-9.606a20.2 20.2 0 0 0 1.867-4.812c.163-.671.29-1.351.29-2.039.009-.68-.108-1.378-.426-1.985"
      />
    </g>
    <mask
      id="linux_svg__R"
      width={68}
      height={70}
      x={158}
      y={174}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M223.455 214.022c-2.049 2.428-4.894 4.032-7.731 5.482-4.83 2.456-9.842 4.622-14.382 7.586-3.045 1.984-5.854 4.314-8.482 6.824-2.248 2.148-4.378 4.44-6.897 6.262-2.546 1.84-5.483 3.172-8.591 3.634-.861.127-1.722.19-2.592.19-2.936 0-5.872-.707-8.573-1.885-2.447-1.06-4.803-2.592-6.217-4.857-1.414-2.284-1.74-5.066-1.74-7.758-.009-4.739.87-9.434 1.695-14.11.688-3.888 1.341-7.775 1.767-11.7.77-7.123.761-14.327.254-21.487-.091-1.196-.191-2.401-.009-3.588.181-1.188.67-2.375 1.576-3.154.843-.725 1.967-1.051 3.082-1.106 1.105-.063 2.211.109 3.308.272 2.582.381 5.192.671 7.721 1.341 1.595.417 3.153.979 4.739 1.414 2.665.716 5.447 1.06 8.175.743 2.945-.344 5.809-1.45 8.772-1.377 1.215.027 2.42.254 3.58.625 1.178.372 2.347.906 3.217 1.794.662.671 1.124 1.514 1.468 2.393.517 1.305.798 2.701.916 4.096.099 1.242.081 2.501.317 3.725.389 2.003 1.45 3.842 2.755 5.41 1.314 1.577 2.882 2.909 4.449 4.223 1.568 1.314 3.136 2.619 4.822 3.77.788.544 1.604 1.051 2.356 1.641.752.598 1.441 1.286 1.912 2.12.408.734.625 1.559.625 2.402 0 .471-.063.942-.208 1.413-.408 1.296-1.16 2.556-2.084 3.662"
      />
    </mask>
    <g filter="url(#linux_svg__S)" mask="url(#linux_svg__R)" opacity={0.35}>
      <path
        fill="url(#linux_svg__T)"
        d="M198.097 179.556c-.435-.625-1.232-1.087-2.129-1.359-.888-.272-1.867-.353-2.837-.353-1.93.018-3.851.38-5.782.253-1.622-.099-3.162-.543-4.748-.815-1.641-.29-3.381-.408-5.003-.082-1.74.335-3.271 1.178-4.232 2.284-.852.97-1.251 2.12-1.378 3.262-.126 1.142.009 2.293.173 3.435.108.825.244 1.658.516 2.465.281.807.707 1.595 1.378 2.266.969.969 2.41 1.658 3.96 2.075 2.537.68 5.419.643 7.912-.1 4.422-1.386 8.165-3.878 10.439-6.942.825-1.105 1.46-2.274 1.867-3.48.163-.489.29-.978.29-1.468.009-.498-.108-1.006-.426-1.441"
      />
    </g>
    <path
      fill="#020204"
      d="M201.779 173.964c-.317-.861-.879-1.622-1.559-2.238s-1.486-1.088-2.329-1.45c-1.686-.716-3.525-.988-5.338-1.323-1.694-.318-3.389-.707-5.093-.997-1.776-.299-3.607-.499-5.365-.1-1.531.344-2.954 1.142-4.114 2.202s-2.066 2.384-2.719 3.816c-1.151 2.528-1.513 5.365-1.296 8.129.163 2.057.689 4.177 2.039 5.727 1.097 1.26 2.646 2.048 4.241 2.519 2.755.816 5.755.771 8.483-.117a22.4 22.4 0 0 0 11.192-8.419c.888-1.296 1.649-2.701 1.994-4.223.263-1.16.272-2.411-.136-3.526"
    />
    <mask
      id="linux_svg__U"
      width={30}
      height={24}
      x={173}
      y={167}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M201.779 173.964c-.317-.861-.879-1.622-1.559-2.238s-1.486-1.088-2.329-1.45c-1.686-.716-3.525-.988-5.338-1.323-1.694-.318-3.389-.707-5.093-.997-1.776-.299-3.607-.499-5.365-.1-1.531.344-2.954 1.142-4.114 2.202s-2.066 2.384-2.719 3.816c-1.151 2.528-1.513 5.365-1.296 8.129.163 2.057.689 4.177 2.039 5.727 1.097 1.26 2.646 2.048 4.241 2.519 2.755.816 5.755.771 8.483-.117a22.4 22.4 0 0 0 11.192-8.419c.888-1.296 1.649-2.701 1.994-4.223.263-1.16.272-2.411-.136-3.526"
      />
    </mask>
    <g filter="url(#linux_svg__V)" mask="url(#linux_svg__U)">
      <path
        fill="url(#linux_svg__W)"
        d="M183.055 167.034a10 10 0 0 0-1.269.154c-2.709.48-5.193 2.193-6.588 4.558a9.73 9.73 0 0 0-1.296 5.592 8.8 8.8 0 0 1 1.078-3.879c1.115-2.021 3.145-3.543 5.42-3.96 1.395-.254 2.836-.1 4.241.072 1.359.172 2.719.354 4.051.635 2.066.453 4.105 1.141 5.836 2.347.399.281.779.598 1.097.978.317.372.561.807.661 1.287.136.707-.063 1.45-.417 2.076-.353.634-.833 1.178-1.341 1.685-.417.417-.852.807-1.296 1.196 2.003-.389 4.024-.933 5.691-2.093.698-.498 1.342-1.087 1.758-1.831.417-.752.59-1.658.39-2.492-.145-.562-.453-1.078-.834-1.513s-.842-.789-1.314-1.124a15.66 15.66 0 0 0-7.077-2.71 83 83 0 0 0-4.912-.752c-1.278-.163-2.592-.299-3.879-.226"
      />
    </g>
    <mask
      id="linux_svg__X"
      width={30}
      height={24}
      x={173}
      y={167}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M201.779 173.964c-.317-.861-.879-1.622-1.559-2.238s-1.486-1.088-2.329-1.45c-1.686-.716-3.525-.988-5.338-1.323-1.694-.318-3.389-.707-5.093-.997-1.776-.299-3.607-.499-5.365-.1-1.531.344-2.954 1.142-4.114 2.202s-2.066 2.384-2.719 3.816c-1.151 2.528-1.513 5.365-1.296 8.129.163 2.057.689 4.177 2.039 5.727 1.097 1.26 2.646 2.048 4.241 2.519 2.755.816 5.755.771 8.483-.117a22.4 22.4 0 0 0 11.192-8.419c.888-1.296 1.649-2.701 1.994-4.223.263-1.16.272-2.411-.136-3.526"
      />
    </mask>
    <g filter="url(#linux_svg__Y)" mask="url(#linux_svg__X)">
      <path
        fill="url(#linux_svg__Z)"
        d="M183.055 167.034a10 10 0 0 0-1.269.154c-2.709.48-5.193 2.193-6.588 4.558a9.73 9.73 0 0 0-1.296 5.592 8.8 8.8 0 0 1 1.078-3.879c1.115-2.021 3.145-3.543 5.42-3.96 1.395-.254 2.836-.1 4.241.072 1.359.172 2.719.354 4.051.635 2.066.453 4.105 1.141 5.836 2.347.399.281.779.598 1.097.978.317.372.561.807.661 1.287.136.707-.063 1.45-.417 2.076-.353.634-.833 1.178-1.341 1.685-.417.417-.852.807-1.296 1.196 2.003-.389 4.024-.933 5.691-2.093.698-.498 1.342-1.087 1.758-1.831.417-.752.59-1.658.39-2.492-.145-.562-.453-1.078-.834-1.513s-.842-.789-1.314-1.124a15.66 15.66 0 0 0-7.077-2.71 83 83 0 0 0-4.912-.752c-1.278-.163-2.592-.299-3.879-.226"
      />
    </g>
    <path
      fill="url(#linux_svg__aa)"
      d="M106.532 46.69c-1.386.073-2.718.717-3.733 1.668-1.024.952-1.74 2.202-2.184 3.516-.88 2.647-.68 5.51-.481 8.293.182 2.51.372 5.075 1.314 7.413.472 1.178 1.133 2.274 2.012 3.18.879.898 1.994 1.596 3.217 1.895a6.47 6.47 0 0 0 3.499-.118c1.132-.363 2.156-1.006 3.008-1.83 1.233-1.206 2.057-2.783 2.538-4.441.48-1.659.616-3.399.589-5.13-.036-2.157-.317-4.323-.988-6.37-.68-2.049-1.758-3.988-3.262-5.538-.725-.752-1.559-1.404-2.493-1.867-.942-.462-1.993-.725-3.036-.67"
    />
    <path
      fill="#020204"
      d="M103.18 58.21c-.29 1.758-.299 3.598.299 5.265.399 1.106 1.06 2.112 1.858 2.973.516.562 1.114 1.07 1.803 1.405.698.335 1.495.47 2.248.29.688-.172 1.287-.617 1.731-1.17s.743-1.214.951-1.893c.625-2.003.526-4.187-.1-6.19-.444-1.46-1.196-2.864-2.356-3.843-.562-.47-1.214-.842-1.921-1.005-.707-.173-1.477-.127-2.139.172-.734.335-1.305.97-1.676 1.685-.372.716-.562 1.514-.698 2.311"
    />
    <mask
      id="linux_svg__ab"
      width={11}
      height={16}
      x={102}
      y={53}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M103.18 58.21c-.29 1.758-.299 3.598.299 5.265.399 1.106 1.06 2.112 1.858 2.973.516.562 1.114 1.07 1.803 1.405.698.335 1.495.47 2.248.29.688-.172 1.287-.617 1.731-1.17s.743-1.214.951-1.893c.625-2.003.526-4.187-.1-6.19-.444-1.46-1.196-2.864-2.356-3.843-.562-.47-1.214-.842-1.921-1.005-.707-.173-1.477-.127-2.139.172-.734.335-1.305.97-1.676 1.685-.372.716-.562 1.514-.698 2.311"
      />
    </mask>
    <g filter="url(#linux_svg__ac)" mask="url(#linux_svg__ab)">
      <path
        fill="url(#linux_svg__ad)"
        d="M106.886 56.94c.191.498.825.68 1.178 1.078.336.38.689.789.879 1.27.354.914-.353 2.274.39 2.926.227.2.698.209.925 0 .897-.815.697-2.456.344-3.616-.326-1.042-1.115-2.039-2.094-2.537-.453-.236-1.132-.426-1.522-.1-.245.218-.218.67-.1.979"
      />
    </g>
    <mask
      id="linux_svg__ae"
      width={18}
      height={27}
      x={99}
      y={46}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M106.532 46.69c-1.386.073-2.718.717-3.733 1.668-1.024.952-1.74 2.202-2.184 3.516-.88 2.647-.68 5.51-.481 8.293.182 2.51.372 5.075 1.314 7.413.472 1.178 1.133 2.274 2.012 3.18.879.898 1.994 1.596 3.217 1.895a6.47 6.47 0 0 0 3.499-.118c1.132-.363 2.156-1.006 3.008-1.83 1.233-1.206 2.057-2.783 2.538-4.441.48-1.659.616-3.399.589-5.13-.036-2.157-.317-4.323-.988-6.37-.68-2.049-1.758-3.988-3.262-5.538-.725-.752-1.559-1.404-2.493-1.867-.942-.462-1.993-.725-3.036-.67"
      />
    </mask>
    <g mask="url(#linux_svg__ae)">
      <path
        fill="url(#linux_svg__af)"
        d="M103.532 52.29c2.103-1.25 4.649-1.54 7.087-1.314 2.429.236 4.776.943 7.132 1.586 1.731.471 3.48.906 5.102 1.668 1.614.76 3.118 1.885 4.015 3.443.145.245.263.508.417.752.154.245.335.472.562.644.226.172.516.29.797.272a.9.9 0 0 0 .408-.118.75.75 0 0 0 .299-.308.97.97 0 0 0 .091-.48 2.3 2.3 0 0 0-.091-.49c-.589-2.148-1.984-3.97-3.036-5.936-.634-1.178-1.16-2.41-1.794-3.588-2.202-4.033-5.818-7.196-9.923-9.253s-8.691-3.045-13.277-3.308c-5.31-.317-10.63.317-15.868 1.242-2.275.398-4.586.87-6.589 2.002-1.006.562-1.93 1.287-2.646 2.194-.725.897-1.233 1.975-1.405 3.117-.154 1.106.01 2.238.4 3.28.38 1.043.978 1.994 1.685 2.855 1.395 1.731 3.199 3.072 4.857 4.559 1.659 1.477 3.19 3.117 5.048 4.34.924.617 1.93 1.124 3 1.423 1.069.3 2.21.381 3.298.154 1.124-.226 2.175-.779 3.09-1.486.916-.698 1.704-1.54 2.457-2.41 1.504-1.75 2.909-3.662 4.884-4.84"
      />
    </g>
    <g filter="url(#linux_svg__ag)">
      <path
        fill="url(#linux_svg__ah)"
        d="M112.261 45.143c1.957 1.83 3.407 4.096 4.395 6.489-.435-2.638-1.115-4.767-2.837-6.49-1.051-.987-2.256-1.857-3.606-2.464-1.197-.535-2.511-.87-3.272-.88-.752-.017-.933 0-1.087.01-.164.009-.281.009.208.072.489.055 1.586.354 2.764.88 1.178.525 2.374 1.395 3.435 2.383"
      />
    </g>
    <path
      fill="url(#linux_svg__ai)"
      d="M131.147 46.69c-2.166 1.495-3.988 3.57-4.876 6.053-1.123 3.127-.698 6.625.39 9.76 1.106 3.218 2.963 6.28 5.764 8.21 1.395.97 3.018 1.632 4.703 1.832 1.695.199 3.444-.082 4.957-.861 1.831-.961 3.236-2.638 4.106-4.513.87-1.886 1.241-3.96 1.359-6.036.145-2.628-.109-5.31-.979-7.803-.942-2.71-2.646-5.21-5.057-6.77a9.85 9.85 0 0 0-3.987-1.513 8.5 8.5 0 0 0-4.232.471c-.762.3-1.468.707-2.148 1.17"
    />
    <path
      fill="#020204"
      d="M136.158 53.252a5.04 5.04 0 0 0-2.311.77 6 6 0 0 0-1.74 1.704c-.933 1.35-1.341 3-1.404 4.64-.046 1.224.09 2.465.498 3.625s1.088 2.239 2.039 3.018a5.9 5.9 0 0 0 3.453 1.35 5.85 5.85 0 0 0 3.562-1.024c.824-.57 1.486-1.36 1.957-2.247.471-.88.761-1.858.888-2.855.227-1.75-.027-3.58-.843-5.157-.806-1.576-2.184-2.872-3.842-3.48-.725-.262-1.495-.398-2.257-.344"
    />
    <mask
      id="linux_svg__aj"
      width={14}
      height={16}
      x={130}
      y={53}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M136.158 53.252a5.04 5.04 0 0 0-2.311.77 6 6 0 0 0-1.74 1.704c-.933 1.35-1.341 3-1.404 4.64-.046 1.224.09 2.465.498 3.625s1.088 2.239 2.039 3.018a5.9 5.9 0 0 0 3.453 1.35 5.85 5.85 0 0 0 3.562-1.024c.824-.57 1.486-1.36 1.957-2.247.471-.88.761-1.858.888-2.855.227-1.75-.027-3.58-.843-5.157-.806-1.576-2.184-2.872-3.842-3.48-.725-.262-1.495-.398-2.257-.344"
      />
    </mask>
    <g filter="url(#linux_svg__ak)" mask="url(#linux_svg__aj)">
      <path
        fill="url(#linux_svg__al)"
        d="M141.206 60.357c.907-.907-.643-3.308-1.857-4.296-.879-.707-3.426-1.46-3.317-.68.108.77 1.259 1.767 2.021 2.529.951.933 2.718 2.882 3.153 2.447"
      />
    </g>
    <mask
      id="linux_svg__am"
      width={23}
      height={29}
      x={125}
      y={44}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M131.147 46.69c-2.166 1.495-3.988 3.57-4.876 6.053-1.123 3.127-.698 6.625.39 9.76 1.106 3.218 2.963 6.28 5.764 8.21 1.395.97 3.018 1.632 4.703 1.832 1.695.199 3.444-.082 4.957-.861 1.831-.961 3.236-2.638 4.106-4.513.87-1.886 1.241-3.96 1.359-6.036.145-2.628-.109-5.31-.979-7.803-.942-2.71-2.646-5.21-5.057-6.77a9.85 9.85 0 0 0-3.987-1.513 8.5 8.5 0 0 0-4.232.471c-.762.3-1.468.707-2.148 1.17"
      />
    </mask>
    <g mask="url(#linux_svg__am)">
      <path
        fill="url(#linux_svg__an)"
        d="M122.945 54.604a18.6 18.6 0 0 1 6.344-3.443c4.758-1.468 10.15-.888 14.355 1.785 1.45.915 2.746 2.057 4.096 3.127 1.341 1.06 2.773 2.057 4.395 2.628.879.308 1.813.489 2.737.39a5 5 0 0 0 2.329-.87 6.1 6.1 0 0 0 1.704-1.831c.87-1.432 1.151-3.172.997-4.84-.299-3.344-2.184-6.289-3.761-9.252-.498-.925-.97-1.867-1.568-2.728-1.821-2.656-4.739-4.405-7.794-5.429s-6.28-1.395-9.479-1.794c-1.432-.181-2.873-.372-4.295-.2-1.641.2-3.181.862-4.785 1.27-.762.199-1.532.335-2.284.552s-1.496.517-2.112 1.006c-.888.716-1.45 1.794-1.694 2.91-.245 1.123-.191 2.283-.01 3.416.354 2.265 1.206 4.468 1.124 6.76-.054 1.568-.553 3.118-.489 4.686.018.462.109 1.404.19 1.857"
      />
    </g>
    <g filter="url(#linux_svg__ao)">
      <path
        fill="url(#linux_svg__ap)"
        d="M138.686 40.258a8 8 0 0 0-.969 1.54 13.8 13.8 0 0 1 4.703 2.003c2.773 1.84 4.876 4.522 6.353 7.513.344-.38.653-.788.924-1.242-1.486-3.117-3.625-5.936-6.488-7.839-1.378-.906-2.909-1.604-4.523-1.975"
      />
    </g>
    <mask
      id="linux_svg__aq"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__ar)" mask="url(#linux_svg__aq)">
      <path
        fill="#000"
        fillOpacity={0.259}
        d="M103.515 92.954c1.332 3.86 4.006 7.15 7.178 9.715 1.051.861 2.165 1.649 3.407 2.202 1.233.562 2.601.879 3.951.761 1.323-.108 2.583-.634 3.743-1.286 1.16-.653 2.229-1.441 3.353-2.148 1.921-1.224 3.979-2.211 5.981-3.299 2.402-1.314 4.74-2.81 6.761-4.658.933-.843 1.794-1.767 2.818-2.492 1.025-.734 2.257-1.26 3.508-1.17.942.064 1.821.463 2.746.662.462.1.933.145 1.404.073.462-.073.916-.263 1.242-.607.399-.417.58-1.015.553-1.595-.019-.571-.218-1.133-.49-1.64-.534-1.025-1.35-1.904-1.713-3-.326-.98-.262-2.03-.235-3.054.027-1.034.009-2.103-.462-3.018-.363-.689-.97-1.242-1.659-1.604-.689-.372-1.468-.562-2.247-.635-1.559-.145-3.118.163-4.686.245-2.066.118-4.15-.136-6.226-.018-2.582.163-5.12.906-7.712.915-2.954.01-5.908-.96-8.827-.498-1.259.2-2.455.652-3.652 1.051-1.205.408-2.447.761-3.715.743-1.441-.027-2.837-.526-4.278-.625-.716-.055-1.45 0-2.129.254-.671.253-1.278.716-1.614 1.359-.19.362-.281.78-.299 1.187-.018.417.037.825.136 1.233.2.797.571 1.55.87 2.31 1.088 2.783 1.323 5.819 2.293 8.637"
      />
    </g>
    <mask
      id="linux_svg__as"
      width={129}
      height={226}
      x={64}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M126.923 12c-5.438 0-10.893 1.07-15.823 3.734-5.238 2.818-9.534 7.331-12.171 12.66-2.647 5.329-3.68 11.02-3.843 17.291-.299 11.908.272 24.396 1.17 35.715.235 3.444.67 5.456.226 9-1.468 7.521-8.048 12.578-11.564 19.185-3.87 7.286-5.5 15.524-8.419 23.245-2.673 7.06-6.425 13.684-8.954 20.798-3.543 9.942-4.603 20.871-2.265 31.166 1.785 7.848 5.51 15.207 10.53 21.505-.725 1.305-1.431 2.637-2.175 3.933-2.329 4.015-5.174 7.83-6.497 12.28-.662 2.22-.925 4.595-.499 6.878s1.586 4.468 3.399 5.918c1.187.943 2.628 1.559 4.105 1.903 1.477.336 3.009.417 4.531.39 5.773-.127 11.373-1.876 16.956-3.344a202 202 0 0 1 9.996-2.338c11.908-2.438 25.194-1.459 36.241.136a130 130 0 0 1 11.137 2.202c5.764 1.396 11.501 3.172 17.428 3.344 1.558.045 3.135-.027 4.658-.362 1.522-.345 2.999-.961 4.214-1.931 1.821-1.45 2.981-3.643 3.407-5.927s.163-4.667-.507-6.896c-1.342-4.459-4.214-8.256-6.589-12.253-.942-1.586-1.812-3.199-2.746-4.785 7.16-8.038 12.923-17.336 16.258-27.549 3.634-11.147 4.305-23.155 2.774-34.782-1.532-11.627-5.22-22.901-10.069-33.577-6.09-13.376-11.21-18.215-14.926-29.97-4.005-12.705-.698-27.74-3.679-39.258-1.06-3.915-2.755-7.658-4.939-11.083-2.556-4.015-5.8-7.604-9.652-10.395C142.492 14.374 134.771 12 126.923 12"
      />
    </mask>
    <g filter="url(#linux_svg__at)" mask="url(#linux_svg__as)" opacity={0.3}>
      <path
        fill="#000"
        d="M99.809 81.962a30.2 30.2 0 0 1 6.851 5.79c1.804 2.076 3.335 4.432 5.701 5.964 1.658 1.087 3.661 1.695 5.691 1.885 2.383.217 4.794-.136 7.096-.761 2.129-.571 4.187-1.387 6.072-2.456 3.597-2.04 6.597-5.03 10.557-6.371.861-.3 1.758-.508 2.592-.87.834-.354 1.622-.897 2.021-1.659.381-.743.363-1.585.489-2.392.136-.87.435-1.704.599-2.565.163-.86.181-1.776-.218-2.564-.335-.653-.942-1.17-1.64-1.505-.698-.326-1.486-.471-2.275-.507-1.559-.073-3.108.299-4.676.426-2.066.172-4.151-.073-6.226-.01-2.583.073-5.129.608-7.712.726-2.946.126-5.882-.309-8.827-.4-1.278-.044-2.565-.026-3.815.182-1.26.2-2.493.59-3.553 1.242-1.033.625-1.876 1.486-2.818 2.22a8.4 8.4 0 0 1-1.523.97c-.553.253-1.16.435-1.776.462-.317.009-.643-.01-.952.036a2.05 2.05 0 0 0-1.332.752 1.75 1.75 0 0 0-.326 1.405"
      />
    </g>
    <path
      fill="url(#linux_svg__au)"
      d="M113.066 65.042c1.387-1.55 2.329-3.444 3.653-5.039.661-.797 1.431-1.531 2.329-2.048.897-.517 1.948-.806 2.981-.716 1.151.1 2.23.67 3.072 1.46.843.788 1.469 1.785 1.967 2.827.48 1.006.861 2.066 1.55 2.936.734.924 1.758 1.55 2.691 2.284.462.362.915.752 1.278 1.214.372.462.652.997.779 1.577a3.34 3.34 0 0 1-.145 1.767 4 4 0 0 1-.987 1.486c-.861.834-2.039 1.287-3.227 1.45-2.374.336-4.776-.371-7.177-.308-2.42.073-4.794.924-7.223.843-1.205-.045-2.438-.344-3.435-1.033a4.55 4.55 0 0 1-1.25-1.314 3.7 3.7 0 0 1-.526-1.722c-.018-.58.118-1.16.354-1.686.226-.534.552-1.015.915-1.468.734-.897 1.631-1.64 2.401-2.51"
    />
    <path
      fill="url(#linux_svg__av)"
      d="M99.908 80.015c.055.235.136.453.254.661.208.345.517.626.843.861.326.245.679.444 1.024.653 1.821 1.15 3.308 2.755 4.631 4.458 1.767 2.284 3.335 4.813 5.7 6.471 1.668 1.178 3.661 1.84 5.691 2.048 2.384.236 4.794-.145 7.096-.825 2.13-.625 4.187-1.504 6.072-2.673 3.598-2.211 6.597-5.456 10.558-6.915.861-.317 1.758-.543 2.592-.933.833-.399 1.622-.979 2.021-1.812.38-.798.362-1.722.489-2.602.136-.933.435-1.84.598-2.773s.181-1.93-.217-2.79c-.336-.708-.943-1.27-1.641-1.623-.698-.362-1.486-.526-2.274-.562-1.559-.072-3.109.326-4.677.471-2.066.19-4.15-.081-6.226-.018-2.582.082-5.129.662-7.712.789-2.945.136-5.881-.317-8.827-.435-1.277-.055-2.564-.037-3.824.18-1.26.21-2.492.644-3.543 1.37-1.024.706-1.84 1.667-2.783 2.483-.471.407-.978.779-1.54 1.05-.553.273-1.169.445-1.794.427-.318-.01-.653-.055-.952.036-.19.063-.363.181-.508.317a3 3 0 0 0-.371.471c-.263.381-.489.789-.68 1.215"
    />
    <mask
      id="linux_svg__aw"
      width={49}
      height={25}
      x={99}
      y={71}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M99.908 80.015c.055.235.136.453.254.661.208.345.517.626.843.861.326.245.679.444 1.024.653 1.821 1.15 3.308 2.755 4.631 4.458 1.767 2.284 3.335 4.813 5.7 6.471 1.668 1.178 3.661 1.84 5.691 2.048 2.384.236 4.794-.145 7.096-.825 2.13-.625 4.187-1.504 6.072-2.673 3.598-2.211 6.597-5.456 10.558-6.915.861-.317 1.758-.543 2.592-.933.833-.399 1.622-.979 2.021-1.812.38-.798.362-1.722.489-2.602.136-.933.435-1.84.598-2.773s.181-1.93-.217-2.79c-.336-.708-.943-1.27-1.641-1.623-.698-.362-1.486-.526-2.274-.562-1.559-.072-3.109.326-4.677.471-2.066.19-4.15-.081-6.226-.018-2.582.082-5.129.662-7.712.789-2.945.136-5.881-.317-8.827-.435-1.277-.055-2.564-.037-3.824.18-1.26.21-2.492.644-3.543 1.37-1.024.706-1.84 1.667-2.783 2.483-.471.407-.978.779-1.54 1.05-.553.273-1.169.445-1.794.427-.318-.01-.653-.055-.952.036-.19.063-.363.181-.508.317a3 3 0 0 0-.371.471c-.263.381-.489.789-.68 1.215"
      />
    </mask>
    <g filter="url(#linux_svg__ax)" mask="url(#linux_svg__aw)">
      <path
        fill="#D9B30D"
        d="M111.473 83.195a5.23 5.23 0 0 0 .507 3.725 5.2 5.2 0 0 0 2.891 2.401c1.541.517 3.281.263 4.722-.49.843-.434 1.604-1.05 2.084-1.866a3.4 3.4 0 0 0 .48-1.323 3 3 0 0 0-.145-1.396 3.1 3.1 0 0 0-.897-1.242 4.1 4.1 0 0 0-1.359-.743c-.979-.326-2.51-.598-3.544-.616-1.83-.036-4.44.308-4.739 1.55"
      />
    </g>
    <mask
      id="linux_svg__ay"
      width={49}
      height={25}
      x={99}
      y={71}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M99.908 80.015c.055.235.136.453.254.661.208.345.517.626.843.861.326.245.679.444 1.024.653 1.821 1.15 3.308 2.755 4.631 4.458 1.767 2.284 3.335 4.813 5.7 6.471 1.668 1.178 3.661 1.84 5.691 2.048 2.384.236 4.794-.145 7.096-.825 2.13-.625 4.187-1.504 6.072-2.673 3.598-2.211 6.597-5.456 10.558-6.915.861-.317 1.758-.543 2.592-.933.833-.399 1.622-.979 2.021-1.812.38-.798.362-1.722.489-2.602.136-.933.435-1.84.598-2.773s.181-1.93-.217-2.79c-.336-.708-.943-1.27-1.641-1.623-.698-.362-1.486-.526-2.274-.562-1.559-.072-3.109.326-4.677.471-2.066.19-4.15-.081-6.226-.018-2.582.082-5.129.662-7.712.789-2.945.136-5.881-.317-8.827-.435-1.277-.055-2.564-.037-3.824.18-1.26.21-2.492.644-3.543 1.37-1.024.706-1.84 1.667-2.783 2.483-.471.407-.978.779-1.54 1.05-.553.273-1.169.445-1.794.427-.318-.01-.653-.055-.952.036-.19.063-.363.181-.508.317a3 3 0 0 0-.371.471c-.263.381-.489.789-.68 1.215"
      />
    </mask>
    <g filter="url(#linux_svg__az)" mask="url(#linux_svg__ay)">
      <path
        fill="#604405"
        d="M106.406 73.497a43 43 0 0 0-3.045 1.994c-.517.371-1.042.761-1.314 1.332-.19.399-.236.852-.245 1.296 0 .453.027.897-.036 1.341-.036.3-.118.598-.127.897-.009.154 0 .308.036.454.046.144.118.29.218.398.136.145.317.236.507.29.191.055.381.082.58.127.916.218 1.713.78 2.411 1.414.698.625 1.332 1.341 2.066 1.93 1.976 1.613 4.595 2.284 7.15 2.32 2.556.045 5.084-.49 7.577-1.051 1.957-.444 3.915-.897 5.791-1.595a25.5 25.5 0 0 0 7.902-4.704c1.06-.915 2.048-1.92 3.235-2.664 1.042-.661 2.212-1.096 3.281-1.722.1-.054.19-.118.272-.181a1 1 0 0 0 .217-.254.8.8 0 0 0 .027-.562 1.6 1.6 0 0 0-.28-.498 4 4 0 0 0-.445-.453c-1.114-.952-2.619-1.296-4.087-1.414-1.459-.109-2.936-.027-4.377-.272-1.359-.226-2.646-.734-3.96-1.15a29 29 0 0 0-4.205-1.025c-3.362-.553-6.815-.444-10.141.245a29.6 29.6 0 0 0-9.008 3.507"
      />
    </g>
    <path
      fill="url(#linux_svg__aA)"
      d="M106.071 69.956a18.8 18.8 0 0 0-4.015 3.66c-.652.807-1.251 1.686-1.577 2.665-.263.78-.353 1.595-.516 2.402-.064.299-.136.598-.127.906 0 .145.018.299.063.453.046.145.127.281.227.39.181.181.426.28.67.335.254.045.508.054.762.082 1.132.135 2.175.68 3.117 1.332.943.643 1.813 1.404 2.782 2.012 2.13 1.35 4.676 1.948 7.205 2.048 2.519.1 5.039-.281 7.522-.78 1.966-.39 3.924-.86 5.791-1.595 2.863-1.132 5.446-2.863 7.902-4.703 1.124-.834 2.23-1.695 3.235-2.664.336-.336.671-.671 1.034-.98.362-.298.77-.561 1.223-.706.689-.218 1.432-.154 2.148-.036.535.09 1.069.208 1.613.19a2.7 2.7 0 0 0 .797-.163c.254-.1.49-.254.662-.471.227-.272.344-.635.344-.988 0-.363-.108-.716-.29-1.024-.362-.617-.987-1.033-1.64-1.323-.897-.4-1.867-.59-2.818-.825a40 40 0 0 1-8.465-3.09c-1.341-.662-2.646-1.396-3.96-2.103-1.359-.725-2.737-1.423-4.205-1.876-3.299-.997-6.887-.67-10.141.462a21.64 21.64 0 0 0-9.343 6.39"
    />
    <mask
      id="linux_svg__aB"
      width={48}
      height={25}
      x={99}
      y={62}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M106.071 69.956a18.8 18.8 0 0 0-4.015 3.66c-.652.807-1.251 1.686-1.577 2.665-.263.78-.353 1.595-.516 2.402-.064.299-.136.598-.127.906 0 .145.018.299.063.453.046.145.127.281.227.39.181.181.426.28.67.335.254.045.508.054.762.082 1.132.135 2.175.68 3.117 1.332.943.643 1.813 1.404 2.782 2.012 2.13 1.35 4.676 1.948 7.205 2.048 2.519.1 5.039-.281 7.522-.78 1.966-.39 3.924-.86 5.791-1.595 2.863-1.132 5.446-2.863 7.902-4.703 1.124-.834 2.23-1.695 3.235-2.664.336-.336.671-.671 1.034-.98.362-.298.77-.561 1.223-.706.689-.218 1.432-.154 2.148-.036.535.09 1.069.208 1.613.19a2.7 2.7 0 0 0 .797-.163c.254-.1.49-.254.662-.471.227-.272.344-.635.344-.988 0-.363-.108-.716-.29-1.024-.362-.617-.987-1.033-1.64-1.323-.897-.4-1.867-.59-2.818-.825a40 40 0 0 1-8.465-3.09c-1.341-.662-2.646-1.396-3.96-2.103-1.359-.725-2.737-1.423-4.205-1.876-3.299-.997-6.887-.67-10.141.462a21.64 21.64 0 0 0-9.343 6.39"
      />
    </mask>
    <g filter="url(#linux_svg__aC)" mask="url(#linux_svg__aB)">
      <path
        fill="#F6DA4A"
        d="M129.19 70.68a1.5 1.5 0 0 0-.707-.463 1.9 1.9 0 0 0-.843-.036c-.562.1-1.069.399-1.541.725-1.332.915-2.51 2.048-3.543 3.299-1.36 1.658-2.483 3.57-2.864 5.682-.063.353-.1.725-.063 1.078.045.363.181.716.444.97.217.226.525.362.833.408.318.045.644 0 .943-.1.598-.2 1.097-.625 1.577-1.042 2.601-2.338 4.957-5.13 5.899-8.5.091-.336.173-.68.173-1.034 0-.353-.091-.707-.308-.988"
      />
    </g>
    <g filter="url(#linux_svg__aD)" opacity={0.8}>
      <path
        fill="url(#linux_svg__aE)"
        d="M114.028 65.524c-.698-.227-1.84.997-1.468 1.622.1.172.417.39.634.272.317-.172.58-.807.925-1.052.226-.163.181-.76-.091-.842"
      />
    </g>
    <g filter="url(#linux_svg__aF)" opacity={0.8}>
      <path
        fill="url(#linux_svg__aG)"
        d="M122.945 65.85c.181.58 1.115.48 1.658.76.472.245.852.78 1.387.798.507.009 1.305-.181 1.368-.689.082-.661-.888-1.087-1.513-1.332-.807-.308-1.84-.471-2.592-.054-.172.1-.362.326-.308.516"
      />
    </g>
    <mask
      id="linux_svg__aH"
      width={49}
      height={34}
      x={99}
      y={62}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M99.908 80.015c.055.235.136.453.254.661.208.345.517.626.843.861.326.245.679.444 1.024.653 1.821 1.15 3.308 2.755 4.631 4.458 1.767 2.284 3.335 4.813 5.7 6.471 1.668 1.178 3.661 1.84 5.691 2.048 2.384.236 4.794-.145 7.096-.825 2.13-.625 4.187-1.504 6.072-2.673 3.598-2.211 6.597-5.456 10.558-6.915.861-.317 1.758-.543 2.592-.933.833-.399 1.622-.979 2.021-1.812.38-.798.362-1.722.489-2.602.136-.933.435-1.84.598-2.773s.181-1.93-.217-2.79c-.336-.708-.943-1.27-1.641-1.623-.698-.362-1.486-.526-2.274-.562-1.559-.072-3.109.326-4.677.471-2.066.19-4.15-.081-6.226-.018-2.582.082-5.129.662-7.712.789-2.945.136-5.881-.317-8.827-.435-1.277-.055-2.564-.037-3.824.18-1.26.21-2.492.644-3.543 1.37-1.024.706-1.84 1.667-2.783 2.483-.471.407-.978.779-1.54 1.05-.553.273-1.169.445-1.794.427-.318-.01-.653-.055-.952.036-.19.063-.363.181-.508.317a3 3 0 0 0-.371.471c-.263.381-.489.789-.68 1.215"
      />
      <path
        fill="#fff"
        d="M106.071 69.956a18.8 18.8 0 0 0-4.015 3.66c-.652.807-1.251 1.686-1.577 2.665-.263.78-.353 1.595-.516 2.402-.064.299-.136.598-.127.906 0 .145.018.299.063.453.046.145.127.281.227.39.181.181.426.28.67.335.254.045.508.054.762.082 1.132.135 2.175.68 3.117 1.332.943.643 1.813 1.404 2.782 2.012 2.13 1.35 4.676 1.948 7.205 2.048 2.519.1 5.039-.281 7.522-.78 1.966-.39 3.924-.86 5.791-1.595 2.863-1.132 5.446-2.863 7.902-4.703 1.124-.834 2.23-1.695 3.235-2.664.336-.336.671-.671 1.034-.98.362-.298.77-.561 1.223-.706.689-.218 1.432-.154 2.148-.036.535.09 1.069.208 1.613.19a2.7 2.7 0 0 0 .797-.163c.254-.1.49-.254.662-.471.227-.272.344-.635.344-.988 0-.363-.108-.716-.29-1.024-.362-.617-.987-1.033-1.64-1.323-.897-.4-1.867-.59-2.818-.825a40 40 0 0 1-8.465-3.09c-1.341-.662-2.646-1.396-3.96-2.103-1.359-.725-2.737-1.423-4.205-1.876-3.299-.997-6.887-.67-10.141.462a21.64 21.64 0 0 0-9.343 6.39"
      />
    </mask>
    <g filter="url(#linux_svg__aI)" mask="url(#linux_svg__aH)">
      <path
        fill="url(#linux_svg__aJ)"
        d="M147.152 74.666a3.5 3.5 0 0 1-.878 1.952c-.477.516-1.078.805-1.669.803-.591 0-1.125-.29-1.485-.806s-.517-1.217-.436-1.949c.041-.363.139-.723.289-1.059s.349-.64.586-.897c.236-.257.506-.46.793-.599.286-.139.585-.21.878-.209.294 0 .576.071.831.21.256.139.479.342.657.6.179.256.309.56.383.896s.092.695.051 1.058"
      />
    </g>
    <defs>
      <filter
        id="linux_svg__b"
        width={30.445}
        height={28.652}
        x={81.064}
        y={107.116}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.64}
        />
      </filter>
      <filter
        id="linux_svg__e"
        width={45.922}
        height={33.037}
        x={122.236}
        y={104.388}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.98}
        />
      </filter>
      <filter
        id="linux_svg__h"
        width={19.657}
        height={20.827}
        x={106.169}
        y={108.343}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.68}
        />
      </filter>
      <filter
        id="linux_svg__k"
        width={8.317}
        height={51.881}
        x={105.892}
        y={133.783}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.25}
        />
      </filter>
      <filter
        id="linux_svg__m"
        width={14.989}
        height={15.153}
        x={169.588}
        y={127.364}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.78}
        />
      </filter>
      <filter
        id="linux_svg__o"
        width={19.78}
        height={19.113}
        x={134.475}
        y={18.48}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.73}
        />
      </filter>
      <filter
        id="linux_svg__q"
        width={12.629}
        height={13.712}
        x={153.178}
        y={79.585}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.78}
        />
      </filter>
      <filter
        id="linux_svg__s"
        width={24.93}
        height={53.648}
        x={64.019}
        y={122.673}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.98}
        />
      </filter>
      <filter
        id="linux_svg__u"
        width={26.713}
        height={68.043}
        x={163.938}
        y={117.454}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.19}
        />
      </filter>
      <filter
        id="linux_svg__x"
        width={81.929}
        height={81.305}
        x={26.21}
        y={165.879}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={3.38}
        />
      </filter>
      <filter
        id="linux_svg__z"
        width={68.994}
        height={72.722}
        x={31.133}
        y={165.472}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={2.1}
        />
      </filter>
      <filter
        id="linux_svg__B"
        width={21.834}
        height={38.563}
        x={75.759}
        y={181.923}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.32}
        />
      </filter>
      <filter
        id="linux_svg__E"
        width={63.573}
        height={68.507}
        x={150.457}
        y={178.883}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.95}
        />
      </filter>
      <filter
        id="linux_svg__I"
        width={78.241}
        height={79.111}
        x={153.429}
        y={167.264}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={4.12}
        />
      </filter>
      <filter
        id="linux_svg__K"
        width={71.432}
        height={71.128}
        x={157.948}
        y={164.551}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={3.12}
        />
      </filter>
      <filter
        id="linux_svg__M"
        width={44.615}
        height={8.591}
        x={162.679}
        y={173.928}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.41}
        />
      </filter>
      <filter
        id="linux_svg__P"
        width={36.385}
        height={32.577}
        x={167.038}
        y={173.59}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={2.45}
        />
      </filter>
      <filter
        id="linux_svg__S"
        width={31.065}
        height={20.949}
        x={169.698}
        y={174.764}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.12}
        />
      </filter>
      <filter
        id="linux_svg__V"
        width={30.796}
        height={16.282}
        x={172.118}
        y={165.254}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.88}
        />
      </filter>
      <filter
        id="linux_svg__Y"
        width={30.796}
        height={16.282}
        x={172.118}
        y={165.254}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.88}
        />
      </filter>
      <filter
        id="linux_svg__ac"
        width={5.862}
        height={8.34}
        x={105.919}
        y={54.907}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.44}
        />
      </filter>
      <filter
        id="linux_svg__ag"
        width={11.424}
        height={10.32}
        x={105.472}
        y={41.551}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.12}
        />
      </filter>
      <filter
        id="linux_svg__ak"
        width={7.25}
        height={7.169}
        x={135.128}
        y={54.151}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.45}
        />
      </filter>
      <filter
        id="linux_svg__ao"
        width={12.501}
        height={11.577}
        x={137.457}
        y={39.998}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.13}
        />
      </filter>
      <filter
        id="linux_svg__ar"
        width={56.949}
        height={36.533}
        x={96.713}
        y={72.623}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={1.75}
        />
      </filter>
      <filter
        id="linux_svg__at"
        width={51.011}
        height={24.925}
        x={98.174}
        y={72.341}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.8}
        />
      </filter>
      <filter
        id="linux_svg__ax"
        width={13.929}
        height={11.029}
        x={109.792}
        y={80.103}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.77}
        />
      </filter>
      <filter
        id="linux_svg__az"
        width={43.911}
        height={20.5}
        x={100.336}
        y={68.093}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.65}
        />
      </filter>
      <filter
        id="linux_svg__aC"
        width={12.804}
        height={15.129}
        x={118.154}
        y={68.69}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.73}
        />
      </filter>
      <filter
        id="linux_svg__aD"
        width={2.176}
        height={2.355}
        x={112.287}
        y={65.296}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.1}
        />
      </filter>
      <filter
        id="linux_svg__aF"
        width={4.828}
        height={2.726}
        x={122.736}
        y={64.882}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.1}
        />
      </filter>
      <filter
        id="linux_svg__aI"
        width={5.431}
        height={6.44}
        x={142.203}
        y={71.442}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_222_416"
          stdDeviation={0.23}
        />
      </filter>
      <radialGradient
        id="linux_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(17.2187 0 0 16.3124 85.443 121.827)"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopOpacity={0.25} />
      </radialGradient>
      <radialGradient
        id="linux_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(21.3874 0 0 16.3124 143.952 131.26)"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopOpacity={0.25} />
      </radialGradient>
      <radialGradient
        id="linux_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(8.4734 0 0 9.06247 115.377 127.52)"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopOpacity={0.25} />
      </radialGradient>
      <radialGradient
        id="linux_svg__Q"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(17.2097 4.61133 -4.84118 18.06755 183.797 188.293)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#110800" />
        <stop offset={0.59} stopColor="#A65A00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#FF921E" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="linux_svg__T"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-2.42 4449.707 -4258.876)scale(17.8893 13.4668)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#110800" />
        <stop offset={0.59} stopColor="#A65A00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#FF921E" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="linux_svg__W"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(5.77603 2.51149 -1.15998 2.66777 197.337 172.063)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C7C7C" />
        <stop offset={1} stopColor="#7C7C7C" stopOpacity={0.33} />
      </radialGradient>
      <radialGradient
        id="linux_svg__aa"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(9.27945 -.09718 .1488 14.20912 108.381 58.59)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEFEFC" />
        <stop offset={0.75} stopColor="#FEFEFC" />
        <stop offset={1} stopColor="#D4D4D4" />
      </radialGradient>
      <radialGradient
        id="linux_svg__af"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-9.35 369.194 -627.988)scale(5.66404 5.22904)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8C8C8" />
        <stop offset={1} stopColor="#797978" />
      </radialGradient>
      <radialGradient
        id="linux_svg__ai"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-1.8 1933.266 -4330.938)scale(12.3612 14.2099)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEFEFC" />
        <stop offset={0.75} stopColor="#FEFEFC" />
        <stop offset={1} stopColor="#D4D4D4" />
      </radialGradient>
      <radialGradient
        id="linux_svg__au"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-36 161.55 -149.09)scale(10.3675 9.40684)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#020204" />
        <stop offset={0.73} stopColor="#020204" />
        <stop offset={1} stopColor="#5C5C5C" />
      </radialGradient>
      <radialGradient
        id="linux_svg__av"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-22.4 256.63 -288.963)scale(24.6046 17.2821)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D2940A" />
        <stop offset={0.75} stopColor="#D89C08" />
        <stop offset={0.87} stopColor="#B67E07" />
        <stop offset={1} stopColor="#946106" />
      </radialGradient>
      <radialGradient
        id="linux_svg__aE"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.19625 0 0 1.28687 113.475 66.267)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A2903" />
        <stop offset={0.55} stopColor="#735208" />
        <stop offset={1} stopColor="#AC8C04" />
      </radialGradient>
      <radialGradient
        id="linux_svg__aG"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(2.51937 0 0 1.46812 124.839 66.103)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A2903" />
        <stop offset={0.55} stopColor="#735208" />
        <stop offset={1} stopColor="#AC8C04" />
      </radialGradient>
      <linearGradient
        id="linux_svg__v"
        x1={51.007}
        x2={88.281}
        y1={186.914}
        y2={249.454}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B98309" />
        <stop offset={1} stopColor="#382605" />
      </linearGradient>
      <linearGradient
        id="linux_svg__C"
        x1={88.425}
        x2={100.152}
        y1={203.062}
        y2={225.156}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBC40C" />
        <stop offset={1} stopColor="#EBC40C" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linux_svg__F"
        x1={163.155}
        x2={166.118}
        y1={204.088}
        y2={225.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linux_svg__G"
        x1={167.296}
        x2={204.851}
        y1={241.298}
        y2={180.416}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3E2A06" />
        <stop offset={1} stopColor="#AD780A" />
      </linearGradient>
      <linearGradient
        id="linux_svg__N"
        x1={177.546}
        x2={176.44}
        y1={175.73}
        y2={185.672}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3CD0C" />
        <stop offset={1} stopColor="#F3CD0C" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linux_svg__Z"
        x1={180.155}
        x2={182.493}
        y1={169.308}
        y2={169.209}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C7C7C" />
        <stop offset={1} stopColor="#7C7C7C" stopOpacity={0.33} />
      </linearGradient>
      <linearGradient
        id="linux_svg__ad"
        x1={106.388}
        x2={110.946}
        y1={54.266}
        y2={62.414}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#757574" stopOpacity={0} />
        <stop offset={0.25} stopColor="#757574" />
        <stop offset={0.5} stopColor="#757574" />
        <stop offset={1} stopColor="#757574" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linux_svg__ah"
        x1={105.754}
        x2={115.623}
        y1={41.464}
        y2={51.541}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#646464" stopOpacity={0} />
        <stop offset={0.31} stopColor="#646464" stopOpacity={0.58} />
        <stop offset={0.47} stopColor="#646464" />
        <stop offset={0.73} stopColor="#646464" stopOpacity={0.26} />
        <stop offset={1} stopColor="#646464" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linux_svg__al"
        x1={136.82}
        x2={142.067}
        y1={54.819}
        y2={61.036}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#949494" stopOpacity={0.39} />
        <stop offset={0.5} stopColor="#949494" />
        <stop offset={1} stopColor="#949494" stopOpacity={0.39} />
      </linearGradient>
      <linearGradient
        id="linux_svg__an"
        x1={132.316}
        x2={149.009}
        y1={44.835}
        y2={54.604}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#747474" />
        <stop offset={0.13} stopColor="#8C8C8C" />
        <stop offset={0.25} stopColor="#A4A4A4" />
        <stop offset={0.5} stopColor="#D4D4D4" />
        <stop offset={0.62} stopColor="#D4D4D4" />
        <stop offset={1} stopColor="#7C7C7C" />
      </linearGradient>
      <linearGradient
        id="linux_svg__ap"
        x1={137.989}
        x2={149.099}
        y1={40.602}
        y2={51.096}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#646464" stopOpacity={0} />
        <stop offset={0.31} stopColor="#646464" stopOpacity={0.58} />
        <stop offset={0.47} stopColor="#646464" />
        <stop offset={0.73} stopColor="#646464" stopOpacity={0.26} />
        <stop offset={1} stopColor="#646464" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linux_svg__aA"
        x1={100.769}
        x2={144.885}
        y1={74.768}
        y2={74.423}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AD780A" />
        <stop offset={0.12} stopColor="#D89E08" />
        <stop offset={0.25} stopColor="#EDB80B" />
        <stop offset={0.39} stopColor="#EBC80D" />
        <stop offset={0.53} stopColor="#F5D838" />
        <stop offset={0.77} stopColor="#F6D811" />
        <stop offset={1} stopColor="#F5CD31" />
      </linearGradient>
      <linearGradient
        id="linux_svg__aJ"
        x1={144.859}
        x2={144.859}
        y1={73.162}
        y2={76.424}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5CE2D" />
        <stop offset={1} stopColor="#D79B08" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgLinux;
